const initialState = {}

const menueWahlReducer = (state = initialState, action) => {
    //    console.log('menueWahlReducer called with', state.MenueWahl, action)
    switch (action.type) {
        case 'menueWahl/Replaced':
            return { ...state, ...action.payload };
        case 'menueWahl/UpdateFruehstueck':
            return { ...state, Fruehstueck: action.payload };
        case 'menueWahl/UpdateMenueWahl':
            return { ...state, MenueWahl: action.payload };
        case 'menueWahl/UpdateAbendessen':
            return { ...state, Abendessen: action.payload };
        case 'menueWahl/UpdateToGo':
            return { ...state, ToGo: action.payload };
        default:
            return state;
    }
}

export default menueWahlReducer;